import { theme } from "./theme";

export default () => {
  return theme;
};
